export default {
    es: {
        company_formation: "FORMACIÓN DE LA COMPAÑÍA",
        company_name_option1: "Nombre de la compañía (1)",
        company_name_option2: "Nombre de la compañía (2)",
        company_type: "Tipo de compañía",
        type_of_business: "Tipo de negocio",
        state_of_formation: "Estado de constitución",
        business_purpose_naics: "Propósito del negocio / Código NAICS",
        tax_status: "Estado fiscal",
        years_in_operation: "Años en operación",
        existing_ein: "EIN existente como propietario único",
        principal_address: "Dirección principal",
        city: "Ciudad",
        state: "Estado",
        zip_code: "Código postal",
        mailing_address: "Dirección postal",
        registered_agent_info: "INFORMACIÓN DEL AGENTE REGISTRADO",
        agent_name: "Nombre",
        agent_email: "Correo electrónico",
        agent_phone: "Teléfono",
        registered_agent_address: "Dirección",
        business_owner: "PROPIETARIO DEL NEGOCIO",
        full_name: "Nombre completo",
        phone_number: "Número de teléfono",
        email: "Correo electrónico",
        date_of_birth: "Fecha de nacimiento",
        ssn: "SSN",
        itin: "ITIN",
        passport: "Pasaporte",
        management_details: "DETALLES DE LA ADMINISTRACIÓN",
        start_operations_date: "Fecha de inicio de operaciones",
        number_of_managers: "Número de gerentes",
        stocks: "Acciones",
        special_licenses_permits: "Licencias / Permisos especiales",
        shareholders: "ACCIONISTAS",
        type: "Tipo",
        address: "Dirección",
        position: "Cargo",
        yes: "Sí",
        no: "No",
        submit: "ACEPTAR INFORMACIÓN DE LA COMPAÑÍA",
        accept_text: `Confirmo que la información proporcionada es precisa y acepto los <span class="terms-link">Términos y Condiciones y la Política de Privacidad</span>, autorizando a BUSINESS a actuar en mi nombre para fines de registro de mi compañía.`,
        successTitle: "¡Información verificada exitosamente!",
        successDescription: "Gracias por confirmar que los datos de tu compañía son correctos y aceptar los términos y condiciones. Tu información ha sido registrada correctamente. Pronto nos pondremos en contacto contigo para continuar con el proceso.",
        invalidLink: "Enlace inválido",
        invalidLinkDescription: "El enlace ha expirado o ya no está disponible.",
        address_continued: "Dirección continuada",

        errorMessage: {
            generalError: {
                title: "Ocurrió un error",
                description: "Por favor, inténtalo de nuevo más tarde.",
            },
            invalid: {
                title: "Enlace inválido",
                description: "El enlace que estás buscando ha expirado o ya no está disponible.",
            }
        },
        members: "MIEMBROS",

        company_files_title: "Documentos de la compañía",
        file: {
            oa: "Acuerdo de operación",
            ein: "Número de identificación del empleador",
            ir: "Registro de incorporación",
            download: "Descargar",
            preview_not_available: "Vista previa no disponible",
            evidence: "Evidencia",
            articleDocument: "Documento del artículo",
        },
        no_files: "No hay archivos disponibles",
        no_files_description: "No hay archivos disponibles para descargar.",
        titleWelcome: "Bienvenido, ",
        textWelcome: "Confirme que todos los datos son correctos antes de continuar con el proceso de registro de su compañía.",
        pageTitle: "Registro de confirmación de información de la compañía",
        fileDescription: "Te compartimos los documentos esenciales para la constitución y operatividad legal de tu empresa, necesarios para avanzar con trámites administrativos y fiscales."
    },
    en: {
        company_formation: "COMPANY FORMATION",
        company_name_option1: "Company Name (1)",
        company_name_option2: "Company Name (2)",
        company_type: "Company Type",
        type_of_business: "Type of Business",
        state_of_formation: "State of Formation",
        business_purpose_naics: "Business Purpose / NAICS Code",
        tax_status: "Tax Status",
        years_in_operation: "Years in Operation",
        existing_ein: "Existing EIN as Sole Proprietorship",
        principal_address: "Principal Address",
        city: "City",
        state: "State",
        zip_code: "Zip Code",
        mailing_address: "Mailing Address",
        registered_agent_info: "REGISTERED AGENT INFO",
        agent_name: "Name",
        agent_email: "Email",
        agent_phone: "Phone",
        registered_agent_address: "Address",
        business_owner: "BUSINESS OWNER",
        full_name: "Full Name",
        phone_number: "Phone Number",
        email: "Email",
        date_of_birth: "Date of Birth",
        ssn: "SSN",
        itin: "ITIN",
        passport: "Passport",
        management_details: "MANAGEMENT DETAILS",
        start_operations_date: "Start of Operations Date",
        number_of_managers: "Number of Managers",
        stocks: "Stocks",
        special_licenses_permits: "Special Licenses / Permits",
        shareholders: "SHAREHOLDERS",
        type: "Type",
        address: "Address",
        position: "Position",
        yes: "YES",
        no: "NO",
        submit: "ACCEPT COMPANY INFORMATION",
        accept_text: `I confirm the information provided is accurate and I accept the <span class="terms-link">Terms & Conditions and Privacy Policy</span>, authorizing BUSINESS to act on my behalf for registration purposes of my company.`,
        successTitle: "Information verified successfully!",
        successDescription: "Thank you for confirming that your business data is correct and accepting the terms and conditions. Your information has been successfully registered. We will contact you soon to continue with the process.",
        invalidLink: "Invalid link",
        invalidLinkDescription: "The link you are looking for has expired or is no longer available.",
        errorMessage: {
            generalError: {
                title: "An error occurred",
                description: "Please try again later.",
            },
            invalid: {
                title: "Invalid link",
                description: "The link you are looking for has expired or is no longer available.",
            }
        },
        address_continued: "Address Continued",
        members: "MEMBERS",
        company_files_title: "Company Documents",
        file: {
            oa: "Operating Agreement",
            ein: "Employer Identification Number",
            ir: "Incorporation Registration",
            download: "Download",
            preview_not_available: "Preview not available",
            evidence: "Evidence",
            articleDocument: "Article Document",
        },
        no_files: "No files available",
        no_files_description: "No files available for download.",
        titleWelcome: "Welcome, ",
        textWelcome: "Please confirm that all data is correct before continuing with the registration process of your company.",
        pageTitle: "Confirmation register company information",
        fileDescription: "We share with you the essential documents for the constitution and legal operation of your company, necessary to proceed with administrative and tax procedures."
    }
};
